import { getApiBaseUrl } from '../data/authStorage';
import httpClient from './httpClient';

const baseUrl = getApiBaseUrl();

export async function createTool(payload) {
  try {
    const response = await httpClient.post(`${baseUrl}/organizations/tools`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function listTools() {
  try {
    const response = await httpClient.get(`${baseUrl}/organizations/tools`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function updateTool(toolId, payload) {
  try {
    const response = await httpClient.patch(`${baseUrl}/organizations/tools/${toolId}`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function listEmployees(params = {}) {
  try {
    const { status = 'approved' } = params;
    const response = await httpClient.get(`${baseUrl}/organizations/employees?status=${encodeURIComponent(status)}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function assignToolsToEmployee(employeeId, toolIds) {
  try {
    const response = await httpClient.patch(`${baseUrl}/organizations/employees/${employeeId}/tools`, { toolIds });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function withdrawToolsFromEmployee(employeeId, toolIds) {
  try {
    const response = await httpClient.patch(`${baseUrl}/organizations/employees/${employeeId}/tools/withdraw`, { toolIds });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}
